<template>
  <section>
    <Title :title-name="title.RebookCanx.titleName" :title-link="title.RebookCanx.titleLink" />
    <div class="rebook_canx">
      <div class="container">
        <div style="margin: 14pt 0">
          Unfortunately we had to cancel your flight due to technical reasons, we can offer you the below alternatives to get you
          to the final destination.<br />
          We can offer you the following solutions.
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">OPTION 1 REBOOK YOUR FLIGHT TO FIRST AVAILABLE OPTION</h3>
        </div>
      </div>
      <div class="container">
        <div style="margin: 14pt 0">
          As the first available option to get you to your destination, is for tomorrow we would like to offer you an
          accommodation for tonight OR if more relevant we would like to offer you a Taxi ride back to home. Please choose one of
          the below most appropriate options. Please accept one of the below.
        </div>
        <div v-if="FlightsSameRoute && FlightsSameRoute[0]">Your first available flight to {{ FlightsSameRoute[0].arr }} is</div>
        <div v-if="FlightsSameRoute && FlightsSameRoute.length > 0">
          <div v-for="(item, key) in FlightsSameRoute" :key="key" class="listFlight">
            {{ moment(item.std).format('H:mm A') }}
            {{ moment(item.std).format('D MMM') }}

            <div class="block-item row" style="margin-bottom: 15pt">
              <div class="container">
                <div class="row flightinfo text-center">
                  <div class="col-4">
                    <div>From</div>
                    <div class="airport-name">{{ item.dep }}</div>
                    <div class="flight-time-der">
                      <div>
                        <i class="fas fa-circle" style="color: rgb(7, 188, 236)"> </i>
                        {{ moment(item.std).format('D MMM') }} <br />
                        {{ moment(item.std).format('H:mmA') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="frame-flight-img" style="margin-top: 11pt">
                      <img src="@/assets/images/flight.png" />
                    </div>
                    <div class="flight-status">
                      <p style="color: #000">Status: <span>On time</span></p>
                    </div>
                    <div class="text-center" style="margin-top: 15pt">
                      <a class="btnDefault" @click="updateNewFlight(item.id)">Accept</a>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>To</div>
                    <div class="airport-name">{{ item.arr }}</div>
                    <div class="flight-time-arr">
                      <div>
                        <i class="fas fa-circle" style="color: rgb(84, 206, 174)"> </i>
                        {{ moment(item.sta).format('D MMM') }} <br />
                        {{ moment(item.sta).format('H:mmA') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="or" style="margin-bottom: 15pt; text-align: center">OR</div>
          </div>
        </div>

        <div class="container">
          <div class="text-right" style="margin: 15pt 0">
            <a href="javascript:void(0);" class="other-option">
              <span class="other-option-down"
                >Other options <i style="font-size: 1em" class="fa fa-chevron-down fa-1x" aria-hidden="true"></i
              ></span>
              <span class="other-option-up"
                >Close options <i style="font-size: 1em" class="fa fa-chevron-up fa-1x" aria-hidden="true"></i
              ></span>
            </a>
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">OPTION 2 I WOULD LIKE TO REBOOK TO ANOTHER DATE</h3>
        </div>
      </div>
      <div class="container">
        Please show me the options
        <div class="text-right" style="margin: 15pt 0">
          <a href="javascript:void(0);" class="btnDefault">Search</a>
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">OPTION 3 REQUEST A REFUND</h3>
        </div>
      </div>
      <div class="container">
        Request an refund voucher so I can use this on a future Jetstar booking.
        <div class="text-right" style="margin: 15pt 0">
          <a href="javascript:void(0);" class="btnDefault">Request Refund</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/RebookCanx.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'RebookCanx',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      FlightsSameRoute: 'RebookCanx/FlightsSameRoute'
    })
  },
  mounted() {
    this.$store.dispatch('RebookCanx/getFlightsSameRoute')
  },
  methods: {
    updateNewFlight: function (flightId) {
      this.$store.dispatch('RebookCanx/updateFlight', { flight_id: flightId, secret: this.secret }).then((response) => {
        if (response.success) {
          window.location.href = '/service-acceptance?secret=' + this.secret
        }
      })
    }
  }
}
</script>
